import classNames from 'classnames'

export const authorClasses = (mainClass, role) =>
  classNames(mainClass, {
    orange: role === 'contributor',
    green: role !== 'contributor',
  })
